Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DClearMask = module.exports.default = {
	ALL: 0x07,
	COLOR: 0x01,
	DEPTH: 0x02,
	STENCIL: 0x04
};